// extracted by mini-css-extract-plugin
module.exports = {"warningIndicator":"_warningIndicator--t1DWR","warningIndicatorIcon":"_warningIndicatorIcon--1N6Cz"};